import { isEmpty } from 'lodash';

/**
 * Validates if a message can be sent based on current state
 * @param {Object} params - Validation parameters
 * @param {string} params.messageBody - Message text content
 * @param {Array} params.recipients - Selected recipients
 * @param {boolean} params.isSending - Whether send is in progress
 * @param {boolean} params.isDetecting - Whether language detection is in progress
 * @param {boolean} params.isTranslating - Whether translation is in progress
 * @returns {boolean} - True if message can be sent
 */
export const canSendMessage = ({
  messageBody,
  recipients,
  isSending,
  isDetecting,
  isTranslating
}) => {
  return !(
    isEmpty(messageBody) ||
    isEmpty(recipients) ||
    isSending ||
    isDetecting ||
    isTranslating
  );
};
